/** Swipe shortcuts reveal controls only; all actions still require a tap. */
export function bindMovementGestures(): void {
  let gesture: { row: HTMLElement; x: number; y: number; offset: number; horizontal: boolean; pointer: number } | undefined;
  let suppressClick: { row: HTMLElement; until: number } | undefined;
  const close = (except?: HTMLElement) => document.querySelectorAll<HTMLElement>('.movement-swipe[data-revealed]').forEach(row => {
    if (row === except) return;
    delete row.dataset.revealed;
    row.style.removeProperty('--swipe-offset');
  });
  document.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.pointerType === 'mouse' || !(event.target instanceof Element)) return;
    const row = event.target.closest<HTMLElement>('.movement-swipe');
    close(row ?? undefined);
    if (!row || event.target.closest('.movement-swipe-action')) return;
    gesture = { row, x: event.clientX, y: event.clientY, offset: row.dataset.revealed === 'edit' ? -96 : row.dataset.revealed === 'related' ? 96 : 0, horizontal: false, pointer: event.pointerId };
  });
  document.addEventListener('pointermove', event => {
    if (!gesture || gesture.pointer !== event.pointerId) return;
    const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
    if (!gesture.horizontal) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { gesture = undefined; return; }
      if (Math.abs(dx) < 12 || Math.abs(dx) <= Math.abs(dy)) return;
      gesture.horizontal = true;
      gesture.row.setPointerCapture(event.pointerId);
      gesture.row.classList.add('swiping');
    }
    event.preventDefault();
    gesture.row.style.setProperty('--swipe-offset', `${Math.max(-96, Math.min(96, gesture.offset + dx))}px`);
  }, { passive: false });
  const finish = (event: PointerEvent) => {
    if (!gesture || gesture.pointer !== event.pointerId) return;
    const { row, horizontal, x, offset } = gesture;
    row.classList.remove('swiping');
    if (horizontal) {
      const distance = event.type === 'pointercancel' ? 0 : offset + event.clientX - x;
      if (Math.abs(distance) >= 40) row.dataset.revealed = distance < 0 ? 'edit' : 'related';
      else delete row.dataset.revealed;
      row.style.removeProperty('--swipe-offset');
      suppressClick = { row, until: performance.now() + 350 };
    }
    gesture = undefined;
  };
  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (suppressClick && performance.now() < suppressClick.until && suppressClick.row.contains(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation(); suppressClick = undefined; return;
    }
    if (!event.target.closest('.movement-swipe')) close();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !document.querySelector('.movement-swipe[data-revealed]')) return;
    close(); event.preventDefault(); event.stopPropagation();
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    const action = event.target.closest<HTMLElement>('.movement-swipe-action');
    const row = action?.closest<HTMLElement>('.movement-swipe');
    if (row && action) { close(row); row.dataset.revealed = action.classList.contains('edit-action') ? 'edit' : 'related'; }
  });
}
